<template>
<div class="MdImg" :style="[
  {
    aspectRatio: item.aspectRatio.replace(':', '/')
  },
  item.flex ? { flex: item.flex } : {}
]"><span :style="{backgroundImage: `url(${item.url})`, backgroundSize: item.aspectMode }"></span></div>
</template>

<script>
export default {
  props: ['item']

}
</script>

<style>

</style>
